// Components
import InputText from '../../InputText';

// Styles
import styles from '../../index.module.sass';

export default function Contact({ contractFields, handleChange, t, typecontract, device }) {
  const { browser = '' } = device || {};
  return (
    <div className={`${styles.personal}`}>
      <div className={styles.areaName}>
        <i className={`material-icons-outlined ${styles.titleIcon}`}>contact_phone</i>
        {t('contactTitle')}
      </div>
      <div className={styles.areaContainer}>
        {/* <div className={`${styles.inputContainer} ${styles.width50}`}>
          <InputText
            type='text'
            placeholder={`${t('phone')}*`}
            className={styles.inputText}
            onChange={handleChange}
            name='telefonoCasa'
            maxLength='10'
            value={contractFields?.telefonoCasa || ''}
            requiredText={t('required')}
            required
          />
        </div> */}
        <div className={`${styles.inputContainer} ${styles.width50}`}>
          <InputText
            type='text'
            placeholder={`${t('cellphone')}*`}
            className={styles.inputText}
            onChange={handleChange}
            name='celular'
            maxLength='10'
            value={contractFields?.celular || ''}
            requiredText={t('required')}
            autoComplete={(browser === 'Chrome' && 'nope') || 'off'}
            required
          />
        </div>
        <div className={`${styles.inputContainer} ${styles.width50}`}>
          <InputText
            type='email'
            placeholder={`${t('email')}*`}
            className={styles.inputText}
            onChange={handleChange}
            name='email'
            maxLength='100'
            value={contractFields?.email || ''}
            requiredText={t('required')}
            autoComplete={(browser === 'Chrome' && 'nope') || 'off'}
            errorText={
              contractFields?.email &&
              contractFields?.email !== '' &&
              !contractFields.emailValidation
                ? t('emailValidation')
                : ''
            }
            error={
              contractFields?.email &&
              contractFields?.email !== '' &&
              !contractFields.emailValidation
                ? true
                : false
            }
            required
          />
        </div>
      </div>
    </div>
  );
}
